import { Footer } from '../components/Footer'
import { SectionRail } from '../components/SectionRail'
import { WarpAccent } from '../components/WarpAccent'
import { VariantHero } from '../components/variants/VariantHero'
import { VariantNav } from '../components/variants/VariantNav'
import { CustomerLogos } from '../components/CustomerLogos'
import { SectionWhy } from '../components/sections/SectionWhy'
import { SectionFeatures } from '../components/sections/SectionFeatures'
import { SectionIntegrations } from '../components/sections/SectionIntegrations'
import { SectionLangy } from '../components/sections/SectionLangy'
import { SectionEnterprise } from '../components/sections/SectionEnterprise'
import { SectionCustomers } from '../components/sections/SectionCustomers'
import { SectionCTA } from '../components/sections/SectionCTA'

export function HomePage() {
  return (
    <div className="site-variant site-variant-2 relative min-h-screen bg-paper text-ink-900">
      <div className="relative z-10">
        <VariantNav />
        <SectionRail />
        <main>
          <VariantHero />
          <section className="bg-paper pt-14 pb-16 md:pt-16 md:pb-20">
            <div className="container-page">
              <CustomerLogos />
            </div>
          </section>
          <SectionWhy />
          <SectionFeatures />
          <SectionIntegrations />
          {/* Langy gets its own mesh instance. */}
          <div className="relative overflow-hidden bg-ink-950">
            <WarpAccent mood="dark" fill opacity={0.6} speed={0.1} />
            <SectionLangy />
          </div>
          {/* Enterprise gets its own mesh instance (different rotation/speed,
              lower opacity) plus a hairline border, so it doesn't read as a
              duplicate of the Langy section right above it. */}
          <div className="relative overflow-hidden border-t border-white/10 bg-ink-950">
            <WarpAccent mood="dark" fill opacity={0.42} speed={0.08} rotation={-42} />
            <SectionEnterprise />
          </div>
          <SectionCustomers />
          <SectionCTA />
        </main>
        <Footer />
      </div>
    </div>
  )
}
